import { useState } from "react";
import { motion } from "framer-motion";
import { Input, Textarea, Checkbox, Button } from "@nextui-org/react";
import emailjs from "emailjs-com";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
};

export default function ContactMe() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    accepted: false,
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .send(
        "service_4v1gpwc",
        "template_ypzum1v",
        {
          user_email: formData.email,
          from_name: `${formData.firstName} ${formData.lastName}`,
          phone: formData.phone,
          message: formData.message,
        },
        "xKTZQV2_Yfc4njEer"
      )
      .then(() => {
        setSent(true);
        setSending(false);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
          accepted: false,
        });
      })
      .catch((err) => {
        console.error("EmailJS error:", err);
        alert("Failed to send. Please try again.");
        setSending(false);
      });
  };

  return (
    <section id="Contact" className="section-padding bg-gray-50 dark:bg-black/50">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          <motion.div {...fadeUp} className="space-y-8">
            <div>
              <h2 className="section-title">Get In Touch</h2>
              <p className="section-subtitle">
                Have a project in mind? Let's work together to build something
                great.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl glass flex items-center justify-center">
                  <svg className="w-5 h-5 text-black dark:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="font-body text-sm text-black/50 dark:text-white/50">Email</p>
                  <p className="font-body font-medium text-black dark:text-white">
                    angelotaruc384@gmail.com
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl glass flex items-center justify-center">
                  <svg className="w-5 h-5 text-black dark:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <p className="font-body text-sm text-black/50 dark:text-white/50">Phone</p>
                  <p className="font-body font-medium text-black dark:text-white">
                    +63 921 475 9372
                  </p>
                </div>
              </div>
            </div>

            {sent && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="rounded-xl bg-black/5 dark:bg-white/5 border-2 border-black/10 dark:border-white/10 p-4"
              >
                <p className="font-body font-medium text-black dark:text-white">
                  Thanks! Your message has been sent.
                </p>
              </motion.div>
            )}
          </motion.div>

          <motion.div
            {...fadeUp}
            transition={{ delay: 0.2 }}
            className="bento-glass-card"
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input
                  label="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  isRequired
                  variant="bordered"
                  classNames={{
                    input: "font-body",
                    inputWrapper:
                      "border-2 border-black/10 hover:border-black/30 rounded-xl dark:border-white/10 dark:hover:border-white/30",
                  }}
                />
                <Input
                  label="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  isRequired
                  variant="bordered"
                  classNames={{
                    input: "font-body",
                    inputWrapper:
                      "border-2 border-black/10 hover:border-black/30 rounded-xl dark:border-white/10 dark:hover:border-white/30",
                  }}
                />
              </div>

              <Input
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                isRequired
                variant="bordered"
                classNames={{
                  input: "font-body",
                  inputWrapper:
                    "border-2 border-black/10 hover:border-black/30 rounded-xl dark:border-white/10 dark:hover:border-white/30",
                }}
              />

              <Input
                label="Phone Number"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                variant="bordered"
                classNames={{
                  input: "font-body",
                  inputWrapper:
                    "border-2 border-black/10 hover:border-black/30 rounded-xl dark:border-white/10 dark:hover:border-white/30",
                }}
              />

              <Textarea
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                isRequired
                rows={4}
                variant="bordered"
                classNames={{
                  input: "font-body",
                  inputWrapper:
                    "border-2 border-black/10 hover:border-black/30 rounded-xl dark:border-white/10 dark:hover:border-white/30",
                }}
              />

              <Checkbox
                name="accepted"
                isSelected={formData.accepted}
                onChange={handleChange}
                isRequired
                classNames={{
                  label: "font-body text-sm text-black/60 dark:text-white/60",
                }}
              >
                I accept the terms and conditions
              </Checkbox>

              <Button
                type="submit"
                isDisabled={sending}
                size="lg"
                className="w-full font-body font-semibold bg-black text-white dark:bg-white dark:text-black
                           py-6 rounded-xl hover:bg-black/90 dark:hover:bg-white/90 transition-all duration-200"
              >
                {sending ? "Sending..." : "Send Message"}
              </Button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
